<!--Tooltip Starts-->
<section id="tooltio">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Tooltips</div>
    </div>
  </div>
  <div class="row text-left">
    <!--Quick and easy tooltips Starts-->
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Quick and easy tooltips</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button type="button" class="btn btn-outline-primary mr-1 mb-1" placement="top" ngbTooltip="Tooltip on top">
              Tooltip on top
            </button>
            <button type="button" class="btn btn-outline-warning mr-1 mb-1" placement="right" ngbTooltip="Tooltip on right">
              Tooltip on right
            </button>
            <button type="button" class="btn btn-outline-success mr-1 mb-1" placement="bottom" ngbTooltip="Tooltip on bottom">
              Tooltip on bottom
            </button>
            <button type="button" class="btn btn-outline-danger mr-1 mb-1" placement="left" ngbTooltip="Tooltip on left">
              Tooltip on left
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Quick and easy tooltips Ends-->
  </div>
  <div class="row text-left">
    <!--HTML and bindings in tooltips Starts-->
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">HTML and bindings in tooltips</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Tooltips can contain any arbitrary HTML, Angular bindings and even directives! Simply enclose desired
              content in
              a <code>&lt;template&gt;</code> element.</p>

            <ng-template #tipContent>Hello, <b>{{name}}</b>!</ng-template>
            <button type="button" class="btn btn-outline-primary" [ngbTooltip]="tipContent">
              I've got markup and bindings in my tooltip!
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--HTML and bindings in tooltips Ends-->
  </div>
  <div class="row text-left">
    <!--Custom and manual triggers Starts-->
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Custom and manual triggers</h4>
          <p> You can easily override open and close triggers by specifying event names (separated by <code>:</code>)
            in the <code>triggers</code> property.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button type="button" class="btn btn-outline-success" ngbTooltip="You see, I show up on click!" triggers="click:blur">
              Click me!
            </button>

            <p class="pt-3">
              Alternatively you can take full manual control over tooltip opening / closing events.
            </p>

            <button type="button" class="btn btn-outline-info mr-1" ngbTooltip="What a great tip!" triggers="manual" #t="ngbTooltip"
              (click)="t.open()">
              Click me to open a tooltip
            </button>
            <button type="button" class="btn btn-outline-warning" (click)="t.close()">
              Click me to close a tooltip
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Custom and manual triggers Ends-->
  </div>
  <div class="row text-left">
    <!--Context and manual triggers Starts-->
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Context and manual triggers</h4>
          <p> You can optionally pass in a context when manually triggering a popover.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #tipContent1 let-greeting="greeting">{{greeting}}, <b>{{name}}</b>!</ng-template>
            <p>
              How would you like to greet <strong [ngbTooltip]="tipContent1" #x="ngbTooltip" triggers="manual">me</strong>?
            </p>
            <button type="button" class="btn btn-outline-primary mr-1" (click)="changeGreeting({ greeting: 'Bonjour' })">
              French
            </button>
            <button type="button" class="btn btn-outline-warning mr-1" (click)="changeGreeting({ greeting: 'Gutentag' })">
              German
            </button>
            <button type="button" class="btn btn-outline-info" (click)="changeGreeting({ greeting: 'Hello' })">
              English
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Context and manual triggers Ends-->
  </div>
  <div class="row text-left">
    <!--Append tooltip in the body Starts-->
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Append tooltip in the body</h4>
          <p>Set the <code>container</code> property to "body" to have the tooltip be appended to the body instead of
            the triggering
            element's parent. This option is useful if the element triggering the tooltip is inside an element that
            clips its
            contents (i.e. <code>overflow: hidden</code>).</p>
        </div>
        <div class="card-content">
          <div class="card-body" style="padding: 50px 0; text-align: center; overflow:hidden">
            <button type="button" class="btn btn-outline-success mr-1" ngbTooltip="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
              Default tooltip
            </button>
            <button type="button" class="btn btn-outline-danger" ngbTooltip="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
              container="body">
              Tooltip appended to body
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Append tooltip in the body Ends-->
  </div>
</section>
<!--Tooltip Ends-->
